import { useEffect } from "react";
import { PairShareState, RECEIVE_QUESTION } from ".";
import { subscribeToolkitReduxDispatches } from "src/state/toolkitReduxStore";
import { toolkitPairshareActions } from "./toolkitPairshareStore";

export function useToolkitPairshareRuntime() {
  useEffect(() => {
    const unsubscribe = subscribeToolkitReduxDispatches((action) => {
      if (action.type !== RECEIVE_QUESTION) {
        return;
      }

      toolkitPairshareActions.setQuestion((action.payload ?? {}) as PairShareState);
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
